import { useSearchParams } from "react-router-dom";
import { Table } from "../../../../../../components/Functional";
import Actions from "./components/Actions";
import SectionHeader from "../../components/SectionHeader";
import { Modal, Button } from "../../../../../../components/ui";
import AddDocuments from "./components/AddDocuments";
import { FETCH_CONSIGNMENT_DOCUMENTS } from "../../../../../../graphql/query/ConsignmentDocument";
import useUser from "../../../../../../hooks/useUser";
import {
  DOCUMENT_FILE_NAME_LABEL_CLASS,
  DOCUMENT_HIGHLIGHT_ROW_CLASS,
  matchesDocumentFilename,
} from "../../../../../../util/documentLink";

const ConsignmentDocuments = props => {
  const { consignment } = props || {};
  const { hasPermission } = useUser();
  const [searchParams] = useSearchParams();
  const highlightedFilename = searchParams.get("filename");

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "consignmentDocuments",
    headers: [
      {
        label: "File Name",
        name: "fileName",
        type: "label",
        labelClass: DOCUMENT_FILE_NAME_LABEL_CLASS,
        widthInPx: 360,
        width: "45%",
      },
      { label: "File Type", name: "fileType", type: "label" },
      { label: "Date", name: "updatedAt", type: "date" },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [{ label: "Name", name: "name", type: "text", view: "partial" }],
    FETCH_QUERY: FETCH_CONSIGNMENT_DOCUMENTS,
    variables: {
      consignmentId: +consignment?.id,
    },
    rowClassName: values =>
      matchesDocumentFilename(values?.fileName, highlightedFilename)
        ? DOCUMENT_HIGHLIGHT_ROW_CLASS
        : "",
  };

  const modalProps = {
    body: AddDocuments,
    closeOnBackdrop: true,
    consignment,
    hideCloseButton: true,
    scale: "md",
    disabled: !hasPermission("UPDATE_CONSIGNMENT"),
  };

  const actions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button
              label="Upload"
              action="black"
              disabled={!hasPermission("UPDATE_CONSIGNMENT")}
            />
          </Modal>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Documents" actions={actions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default ConsignmentDocuments;
